export const districts = [
  { name: 'First Light Isle', note: 'Choose where Lumina’s first warm window will glow.', colors: ['#25dbf4', '#ffc84d'] },
  { name: 'Brightbrook Reach', note: 'Help a wandering spring find its way home.', colors: ['#28c8f5', '#64d95b'] },
  { name: 'Starwell Terrace', note: 'Bring different pieces together to restore a Wonder.', colors: ['#a95bff', '#25dbf4'] },
  { name: 'Bloomcap Crossing', note: 'Discover what good neighbors can grow.', colors: ['#ff7d6a', '#64d95b'] },
  { name: 'Frostsong Reach', note: 'Teach a frozen observatory to find its rhythm.', colors: ['#b7eaff', '#9270ff'] },
  { name: 'Emberwatch Bastion', note: 'Make variation safe without making it identical.', colors: ['#ff7d36', '#ffc84d'] },
  { name: 'Skyglass Ruins', note: 'Follow the predicted path—or prove another one works.', colors: ['#9da7bd', '#25dbf4'] },
  { name: 'Lumina Confluence', note: 'Connect every district and choose what leads.', colors: ['#ffc84d', '#a95bff'] },
]

export const promises = [
  'No combat',
  'No ads',
  'No energy timers',
  'No loot boxes',
  'No paid retries',
  'Offline after download',
  'Captions & motion controls',
  'Multiple ways to solve',
]

export const characterLines = [
  { name: 'Mira', role: 'Garden keeper', line: 'They grow better together.', palette: '#ff7d6a' },
  { name: 'Pip', role: 'Light tinkerer', line: 'This way feels new.', palette: '#ffc84d' },
  { name: 'Ori', role: 'Sky cartographer', line: 'What should we make tomorrow?', palette: '#25dbf4' },
]
